export default __webpack_public_path__ + "static/media/avatar.9d644810.jpg";